import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

const BlogCards = ({ data }) => {
  return (
    <>
      <div className="blog-cards">
        <div className="blog-cards__grid">
          {data?.map((b, i) => (
            <div key={i} className="blog-cards__grid-item">
              <div className="blog-cards__grid-item__image gap-3x">
                {b?.image?.localFile?.childImageSharp?.gatsbyImageData ? (
                  <GatsbyImage
                    image={b.image?.localFile?.childImageSharp?.gatsbyImageData}
                    alt={b?.title}
                    className="img-w-100"
                  />
                ) : (
                  <img
                    src={b?.image?.localFile?.publicURL}
                    alt={b?.title}
                    className="img-w-100"
                  />
                )}
              </div>
              <div className="blog-cards__grid-item__category gap-1x">
                {b.categories.map((c) => (
                  <Link
                    to={`/blog/${c.slug}`}
                    className="text-p3 font--secondary text-clr-primary text-fw-medium"
                  >
                    {c.title}
                  </Link>
                ))}
              </div>
              <Link
                to={`/blog/${b.slug}`}
                className="blog-cards__grid-item__title font--primary gap-2x text-h3 text-clr-primary text-fw-medium"
              >
                {b.title}
              </Link>
              <div className="blog-cards__grid-item__info">
                <GatsbyImage
                  image={
                    b?.authorImage?.localFile?.childImageSharp?.gatsbyImageData
                  }
                  alt={b?.authorImage?.title}
                />
                <p className="text-p2 font--secondary text-fw-medium text-clr-primary">
                  by {b.author}
                </p>
                <p className="text-p2 font--secondary text-fw-regular text-clr-grey-3">
                  {b.readTime}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogCards;

// import { Link } from "gatsby";
// import { GatsbyImage } from "gatsby-plugin-image";
// import React from "react";
// // import VehicalRouteImg from "../images/Vehicle_routing.png";

// const BlogCards = ({ data, whitepaper }) => {
//   return (
//     <>
//       {whitepaper ? (
//         <div className="blog-cards">
//           <div className="blog-cards__grid">
//             {data?.map((b, i) => (
//               <div key={i} className="blog-cards__grid-item">
//                 <div className="blog-cards__grid-item__image gap-3x">
//                   {b?.bannerImage?.localFile?.childImageSharp
//                     ?.gatsbyImageData ? (
//                     <GatsbyImage
//                       image={
//                         b.bannerImage?.localFile?.childImageSharp
//                           ?.gatsbyImageData
//                       }
//                       alt={b?.title}
//                       className="img-w-100"
//                     />
//                   ) : (
//                     <img
//                       src={b?.bannerImage?.localFile?.publicURL}
//                       alt={b?.title}
//                       className="img-w-100"
//                     />
//                   )}
//                 </div>
//                 <div className="blog-cards__grid-item__category gap-1x">
//                   {b.white_paper_tags.map((c) => (
//                     // <Link
//                     //   to={`/blog/${c.slug}`}
//                     //   className="text-p3 font--secondary text-clr-primary text-fw-medium"
//                     // >
//                     //   {c.tag}
//                     // </Link>
//                     <p className="text-p3 blog-detail-content__contact-grid__tags-list__item text-fw-medium  font--secondary">
//                       {c.tag}
//                     </p>
//                   ))}
//                 </div>
//                 <Link
//                   to={`/whitepaper/${b.slug}`}
//                   className="blog-cards__grid-item__title font--primary gap-2x text-h3 text-clr-primary text-fw-medium"
//                 >
//                   {b.title}
//                 </Link>
//                 {/* {b.authors?.map((e, i) => (
//                   <div className="blog-cards__grid-item__info" key={i}>
//                     <GatsbyImage
//                       image={
//                         e?.authorImage?.localFile?.childImageSharp
//                           ?.gatsbyImageData
//                       }
//                       alt={b?.authorImage?.title}
//                     />
//                     <p className="text-p2 font--secondary text-fw-medium text-clr-primary">
//                       by {e.author}
//                     </p>
//                     <p className="text-p2 font--secondary text-fw-regular text-clr-grey-3">
//                       {e.readTime}
//                     </p>
//                   </div>
//                 ))} */}
//               </div>
//             ))}
//           </div>
//         </div>
//       ) : (
//         <div className="blog-cards">
//           <div className="blog-cards__grid">
//             {data?.map((b, i) => (
//               <div key={i} className="blog-cards__grid-item">
//                 <div className="blog-cards__grid-item__image gap-3x">
//                   {b?.image?.localFile?.childImageSharp?.gatsbyImageData ? (
//                     <GatsbyImage
//                       image={
//                         b.image?.localFile?.childImageSharp?.gatsbyImageData
//                       }
//                       alt={b?.title}
//                       className="img-w-100"
//                     />
//                   ) : (
//                     <img
//                       src={b?.image?.localFile?.publicURL}
//                       alt={b?.title}
//                       className="img-w-100"
//                     />
//                   )}
//                   {/* {(() => {
//                     const media = b?.image?.localFile;

//                     if (!media) return null;
//                     if (media?.childImageSharp?.gatsbyImageData) {
//                       return (
//                         <GatsbyImage
//                           image={media.childImageSharp.gatsbyImageData}
//                           alt={b?.title}
//                           className="img-w-100"
//                         />
//                       );
//                     }
//                     if (
//                       media?.publicURL &&
//                       media?.extension?.match(/(mp4|webm|ogg)$/i)
//                     ) {
//                       return (
//                         <img
//                           src={VehicalRouteImg}
//                           alt={b?.title}
//                           className="img-w-100"
//                         />
//                       );
//                     }
//                     return (
//                       <img
//                         src={media?.publicURL}
//                         alt={b?.title}
//                         className="img-w-100"
//                       />
//                     );
//                   })()} */}
//                 </div>
//                 <div className="blog-cards__grid-item__category gap-1x">
//                   {b.categories.map((c) => (
//                     <Link
//                       to={`/blog/${c.slug}`}
//                       className="text-p3 font--secondary text-clr-primary text-fw-medium"
//                     >
//                       {c.title}
//                     </Link>
//                   ))}
//                 </div>
//                 <Link
//                   to={`/blog/${b.slug}`}
//                   className="blog-cards__grid-item__title font--primary gap-2x text-h3 text-clr-primary text-fw-medium"
//                 >
//                   {b.title}
//                 </Link>
//                 <div className="blog-cards__grid-item__info">
//                   <GatsbyImage
//                     image={
//                       b?.authorImage?.localFile?.childImageSharp
//                         ?.gatsbyImageData
//                     }
//                     alt={b?.authorImage?.title}
//                   />
//                   <p className="text-p2 font--secondary text-fw-medium text-clr-primary">
//                     by {b.author}
//                   </p>
//                   <p className="text-p2 font--secondary text-fw-regular text-clr-grey-3">
//                     {b.readTime}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default BlogCards;
